 
  
  //===================
//SIDEBAR PRINCIPAL
//==================
import "./styles.scss";
import React, { useRef, useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { FaPencilAlt, FaHome, FaWrench, FaChevronDown } from "react-icons/fa";
import { HiOutlineLogout } from "react-icons/hi";
import inovalogo from "../../assets/inova@2x.png";
import inovalogomine from "../../assets/logo.png";
import MapaInova from "../../pages/Maps&Actions";
import userP from "../../assets/userP.png";
import { TbFileAnalytics } from "react-icons/tb";
import { BrowserRouter, Routes, Route, NavLink, useLocation } from "react-router-dom";
import { MdGroups } from "react-icons/md";
import { MdPhotoLibrary } from "react-icons/md";
import { MdContacts } from "react-icons/md";
import { TbNurseFilled } from "react-icons/tb";
import { MdNotificationsActive } from "react-icons/md";
import { FaClipboardUser } from "react-icons/fa6";
import { LiaRouteSolid } from "react-icons/lia";
import Swal from "sweetalert2";
import {
  House,
  ClipboardPenLine,
  ChartNoAxesCombined,
  Wrench,
  LogOut,
  ChevronRight,
} from "lucide-react";



function SideBar({ extraClass = "", isBlocked }) {
  const sideBarRef = useRef(null);
  const homeRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [menuAberto, setMenuAberto] = useState(null);

  const [senhaAtual, setSenhaAtual] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");




  const onMouseLeaveSidebar = () => {
    sideBarRef.current.classList.remove("active");
    homeRef.current.classList.remove("active");
  };
  const handleLogout = () => {

    const zoomAvisoOculto =
      localStorage.getItem("zoomAvisoOculto");


    if (zoomAvisoOculto) {
      localStorage.setItem(
        "zoomAvisoOculto",
        zoomAvisoOculto
      );
    }

    document.cookie
      .split(";")
      .forEach((cookie) => {
        document.cookie = cookie
          .replace(/^ +/, "")
          .replace(
            /=.*/,
            `=;expires=${new Date(0).toUTCString()};path=/`
          );
      });

    window.location.href = "/";
  };

  const nomeUsuario = localStorage.getItem("nome") || "Usuário";

  const handleAlterarSenha = async (e) => {
    e.preventDefault();

    if (novaSenha !== confirmarSenha) {
      alert("As novas senhas não coincidem.");
      return;
    }

    const token = localStorage.getItem("inova");
    if (!token) {
      alert("Usuário não identificado.");
      return;
    }

    try {
      const response = await fetch("http://localhost:3333/usuario/alterar-senha", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          inova: `Bearer ${token}`,
        },
        body: JSON.stringify({
          senhaAtual,
          novaSenha,
        }),
      });

      let data;
      try {
        data = await response.json();
      } catch (e) {
        console.error("Erro ao converter resposta em JSON:", e);
        alert("Erro inesperado na resposta do servidor.");
        return;
      }

      if (response.ok) {
        alert(data.mensagem || "Senha alterada com sucesso.");
        setSenhaAtual("");
        setNovaSenha("");
        setConfirmarSenha("");
        document.getElementById("form-alterar-senha").reset();
      } else {
        if (response.status === 401) {
          alert(data.mensagem || "Senha atual incorreta.");
        } else {
          alert(data.mensagem || "Erro ao alterar senha.");
        }
        setSenhaAtual("");
        setNovaSenha("");
        setConfirmarSenha("");
        document.getElementById("form-alterar-senha").reset();
      }
    } catch (error) {
      console.error("Erro na requisição:", error);
      alert("Erro na requisição. Tente novamente.");
    }
  };
  //==============================================================================================================================
  //MOVIMENTAÇÃO MOUSE - ABRE AO PASSAR NA BORDA, MANTÉM ABERTA SE O MOUSE ESTIVER SOBRE A SIDEBAR, FECHA SE O MOUSE ESTIVER FORA
  //==============================================================================================================================

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (isBlocked) return; //  BLOQUEIA TUDO

      const sidebar = sideBarRef.current;
      if (!sidebar) return;

      const sidebarRect = sidebar.getBoundingClientRect();

      const tolerance = 250;

      const mouseInsideSidebar =
        e.clientX >= sidebarRect.left - tolerance &&
        e.clientX <= sidebarRect.right + tolerance;

      // Abre se encostar na borda esquerda
      if (e.clientX <= 68) {
        sidebar.classList.add("active");
        homeRef.current.classList.add("active");
        return;
      }

      if (mouseInsideSidebar) return;

      // Fecha se sair
      sidebar.classList.remove("active");
      homeRef.current.classList.remove("active");
    };

    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, [isBlocked]);

  useEffect(() => {
    if (isBlocked) {
      sideBarRef.current?.classList.remove("active");
      homeRef.current?.classList.remove("active");
    }
  }, [isBlocked]);





  const cadastrosMenu = [
    { nome: "Grupo", rota: "/maps/grupos", icone: <MdGroups /> },
    { nome: "Icones", rota: "/maps/icones", icone: <MdPhotoLibrary /> },
    { nome: "Motorista", rota: "/maps/motorista", icone: <MdContacts /> },
    { nome: "Enfermeiro", rota: "/maps/enfermeiro", icone: <TbNurseFilled /> },
    { nome: "Notificacao", rota: "/maps/notificacao", icone: <MdNotificationsActive /> },
    { nome: "Usuários", rota: "/maps/usuarios", icone: <FaClipboardUser /> },
    {
      nome: "Áreas e Rotas",
      rota: "/maps/areas-rotas",
      icone: <LiaRouteSolid />,
      novaAba: true
    }
  ];
  const cadastrosOrdenados = [...cadastrosMenu].sort((a, b) =>
    a.nome.localeCompare(b.nome, "pt-BR")
  );






useEffect(() => {
  const sidebar = sideBarRef.current;

  if (!sidebar) return;

  const observer = new MutationObserver(() => {
    if (!sidebar.classList.contains("active")) {
      setMenuAberto(null);
    }
  });

  observer.observe(sidebar, {
    attributes: true,
    attributeFilter: ["class"],
  });

  if (!sidebar.classList.contains("active")) {
    setMenuAberto(null);
  }

  return () => observer.disconnect();
}, [extraClass]);




return (
  <>
    <div
      ref={sideBarRef}
      className={`sidebar ${extraClass} ${isBlocked ? "blocked" : ""}`}
    >
      <div className="sidebar-main-content">
        {/* LOGO */}
        <div className="logo_content">
          <div className="logo2">
            <NavLink to="/maps">
              <img
                src={inovalogomine}
                alt="Logo INOVA"
                style={{ width: "40px" }}
              />
            </NavLink>
          </div>

          <div className="logo">
            <img src={inovalogo} alt="Logo INOVA" />
          </div>
        </div>

        <ul className="hr423" />

        {/* PERFIL */}
        <div
          className="perfil-menu"
          onClick={() => {
            Swal.fire({
              title: "Atualizar cadastro?",
              html: `
                <div class="swal-tech-description">
                  Você será direcionado para a área de atualização
                  dos seus dados.
                </div>
              `,
              iconHtml: `
                <div class="swal-tech-question">?</div>
              `,
              showCancelButton: true,
              confirmButtonText: "Continuar",
              cancelButtonText: "Cancelar",
              reverseButtons: true,
              buttonsStyling: false,
              customClass: {
                popup: "swal-tech",
                icon: "swal-tech-icon",
                title: "swal-tech-title",
                htmlContainer: "swal-tech-html",
                actions: "swal-tech-actions",
                confirmButton: "swal-tech-confirm",
                cancelButton: "swal-tech-cancel",
              },
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.href = "/atualizacao-cadastro";
              }
            });
          }}
        >
          <div className="perfil-avatar">
            <img src={userP} alt="Usuário" />
          </div>

          <div className="perfil-user">
            <span>{nomeUsuario}</span>
            <small>Minha conta</small>
          </div>

          <div className="perfil-indicator">
            <span />
          </div>
        </div>

        {/* PÁGINA INICIAL */}
        <ul className="nav_list sidebar-home-list">
          <li>
            <NavLink to="/maps" end>
              <House
                className="sidebar-icon-premium"
                size={25}
                strokeWidth={1.8}
              />
              <span className="links_name">Página Inicial</span>
            </NavLink>
          </li>
        </ul>

        {/* GESTÃO */}
        <div className="sidebar-section-title">
          <span>GESTÃO</span>
          <div className="sidebar-section-line" />
        </div>

        {/* CADASTROS */}
        <ul className="nav_list">
          <li
            className={`menu_item ${
              menuAberto === "cadastros" ? "open" : ""
            }`}
          >
            <a
              href="#cadastros"
              className="nav_parent"
              aria-expanded={menuAberto === "cadastros"}
              onClick={(e) => {
                e.preventDefault();

                setMenuAberto((atual) =>
                  atual === "cadastros" ? null : "cadastros"
                );
              }}
            >
              <ClipboardPenLine
                className="sidebar-icon-premium"
                size={25}
                strokeWidth={1.8}
              />

              <span className="links_name">Cadastros</span>

              <ChevronRight
                className="sidebar-chevron-premium"
                size={19}
              />
            </a>

            {menuAberto === "cadastros" && (
              <ul className="sub_menu">
                {cadastrosOrdenados.map((item, index) => (
                  <li key={item.rota || index}>
                    {item.novaAba ? (
                      <a
                        href={item.rota}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => setMenuAberto(null)}
                      >
                        <span>{item.nome}</span>
                        <span className="iconesSide-Bar">
                          {item.icone}
                        </span>
                      </a>
                    ) : (
                      <NavLink
                        to={item.rota}
                        onClick={() => setMenuAberto(null)}
                      >
                        <span>{item.nome}</span>
                        <span className="iconesSide-Bar">
                          {item.icone}
                        </span>
                      </NavLink>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </li>
        </ul>

        {/* RELATÓRIOS */}
        <ul className="nav_list">
          <li
            className={`menu_item ${
              menuAberto === "relatorio" ? "open" : ""
            }`}
          >
            <a
              href="#relatorios"
              className="nav_parent"
              aria-expanded={menuAberto === "relatorio"}
              onClick={(e) => {
                e.preventDefault();

                setMenuAberto((atual) =>
                  atual === "relatorio" ? null : "relatorio"
                );
              }}
            >
              <ChartNoAxesCombined
                className="sidebar-icon-premium"
                size={25}
                strokeWidth={1.8}
              />

              <span className="links_name">Relatório</span>

              <ChevronRight
                className="sidebar-chevron-premium"
                size={19}
              />
            </a>

            {menuAberto === "relatorio" && (
              <ul className="sub_menu">
                <li>
                  <NavLink
                    to="/relatorio/posicao"
                    target="_blank"
                    onClick={() => setMenuAberto(null)}
                  >
                    Posição
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/relatorio/motorista"
                    target="_blank"
                    onClick={() => setMenuAberto(null)}
                  >
                    Motorista
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/relatorio/produtividade"
                    target="_blank"
                    onClick={() => setMenuAberto(null)}
                  >
                    Produtividade
                  </NavLink>
                </li>

                <li>
                  <NavLink
                      to="/relatorio/relatorio-notificacao"
                      // to="/404"
                      target="_blank"
                      onClick={() => setMenuAberto(null)}
                    >
                      Notificação
                    </NavLink>
                  </li>
              </ul>
            )}
          </li>
        </ul>

        {/* OPERAÇÃO */}
        <div className="sidebar-section-title">
          <span>OPERAÇÃO</span>
          <div className="sidebar-section-line" />
        </div>

        {/* MANUTENÇÃO */}
        <ul className="nav_list">
          <li
            className={`menu_item ${
              menuAberto === "manutencao" ? "open" : ""
            }`}
          >
            <a
              href="#manutencao"
              className="nav_parent"
              aria-expanded={menuAberto === "manutencao"}
              onClick={(e) => {
                e.preventDefault();

                setMenuAberto((atual) =>
                  atual === "manutencao" ? null : "manutencao"
                );
              }}
            >
              <Wrench
                className="sidebar-icon-premium"
                size={25}
                strokeWidth={1.8}
              />

              <span className="links_name">Manutenção</span>

              <ChevronRight
                className="sidebar-chevron-premium"
                size={19}
              />
            </a>

            {menuAberto === "manutencao" && (
              <ul className="sub_menu">
                <li>
                  <NavLink
                    to="manutencao"
                    onClick={() => setMenuAberto(null)}
                  >
                    Revisões
                  </NavLink>
                </li>
              </ul>
            )}
          </li>
        </ul>
      </div>

      {/* SAIR */}
      <ul className="nav_list profile_content">
        <li className="sidebar-logout-item">
          <NavLink to="/" onClick={handleLogout}>
            <LogOut
              className="sidebar-icon-premium"
              size={25}
              strokeWidth={1.8}
            />
            <span className="links_name">Sair</span>
          </NavLink>
        </li>
      </ul>
    </div>

    {/* CONTEÚDO PRINCIPAL */}
    <div className="home_content" ref={homeRef}>
      <MapaInova />
    </div>
  </>
);






}

export default SideBar;


